<template>
  <div v-clickoutside="closePicker" :style="style" :class="classes" class="SpDatePicker">
    <div ref="datePicker" class="input" @click="openPicker">
      <SpIcon v-if="icon" type="calender" class="icon" size="30" />
      <span class="label sp-color-7" :style="{paddingLeft: icon ? '0': '10px'}">{{ label }}</span>
      <SpIcon v-if="model && showClose" type="closeBlack" class="close-icon" size="12" @click.stop="model = ''" />
    </div>
    <SpPopper v-model="showPicker" type="select" min-width="380" height="410" :pop-style="{...popStyle,backgroundColor:'white'}">
      <div class="datepicker" @click.stop="regenPosition">
        <div class="datepicker-year-month">
          <div>
            <SpIcon type="pageLeftDouble" class="arrow-left" @click="addYear(-1)" />

            <SpIcon v-show="pickerOption!=='year'" type="pageLeft" class="arrow-left" @click="addMonth(-1)" />
          </div>
          <div class="label">
            <span class="label-year" @click="pickYear">{{ year }}</span>
            <span class="label-month" @click="pickerOption='month'">{{ getMonth(month) }}</span>
          </div>

          <div>
            <SpIcon v-show="pickerOption!=='year'" type="pageLeft" class="arrow-right" @click="addMonth(1)" />
            <SpIcon type="pageLeftDouble" class="arrow-right" @click="addYear(1)" />
          </div>
        </div>
        <div class="datepicker-panel">
          <transition name="tst-scale">
            <div v-if="pickerOption==='day'" class="datepicker-day">
              <table class="picker-days">
                <thead>
                  <tr>
                    <th>Sun</th><th>Mon</th><th>Tue</th><th>Wed</th><th>Thu</th><th>Fri</th><th>Sat</th>
                  </tr>
                </thead>
                <tr v-for="(ds,key) in days" :key="'tr'+key">
                  <td v-for="(d,dkey) in ds" :key="'tr'+dkey" class="picker-day sp-color-bg-hover-3"
                      :class="{'last-month-date':d.last,'next-month-date':d.next,'sp-color-bg-3':d.curr&&d.date==day}"
                      @click="setDay(d)">
                    {{ d.date }}
                  </td>
                </tr>
              </table>
            </div>
          </transition>
          <transition name="tst-scale">
            <div v-if="pickerOption==='month'" class="datepicker-month">
              <table class="picker-months">
                <template v-for="(mon,index) in months">
                  <tr v-if="(index+1)%4==1" :key="'months-'+index">
                    <td v-for="i in 4" :key="'month-'+index+i" class="picker-month sp-color-bg-hover-3"
                        :class="{'sp-color-bg-3':month==index+i}"
                        @click="setMonth(index+i)">
                      {{ months[index+i-1].slice(0,3) }}
                    </td>
                  </tr>
                </template>
              </table>
            </div>
          </transition>
          <transition name="tst-scale">
            <div v-if="pickerOption==='year'" class="datepicker-year">
              <table class="picker-years">
                <template v-for="(y,key,index) in years">
                  <tr v-if="(index+1)%5==1" :key="'years-'+index">
                    <td v-for="i in 5" :key="'year-'+index+i" class="picker-year sp-color-bg-hover-3"
                        :class="{'sp-color-bg-3':years[index+i-1]==year}"
                        @click="setYear(years[index+i-1])">
                      {{ years[index+i-1] }}
                    </td>
                  </tr>
                </template>
              </table>
            </div>
          </transition>
        </div>
      </div>
    </SpPopper>
  </div>
</template>

<script type="text/ecmascript-6">
import clickoutside from '@/directives/clickOutside'
import WHcomputed from '@/mixins/WHcomputed'
import { getDate } from '@/utils/convert'
import SpPopper from '@/components/common/SpPopper'
import { computed, ref, watch } from 'vue'
import SpIcon from './SpIcon.vue'
import useForm, { useFormItemProps } from '@/hooks/useForm'
import { useSize } from '@/mixins/size'
import { toRef } from '@vue/reactivity'
import { nextTick } from '@vue/runtime-core'
import { isDate } from '@/utils'
import _intersection from 'lodash/intersection'
import moment from 'moment'
const THEME = {
  normal: 'sp-color-bg-4',
  primary: 'sp-color-bg-1',
  warn: 'sp-color-bg-6',
  warn2: 'sp-color-bg-6-6',
  warn3: 'sp-color-bg-2-6',
  warn4: 'sp-color-bd-1-solid-6',

  gray: 'sp-color-bg-5',
  grayBorder1: 'sp-color-bd-1-solid-7',
  grayBorder18: 'sp-color-bd-1-solid-18-3'
}
export default {
  name: 'SpDatePicker',

  nameSpace: 'SpDatePicker',

  components: {
    SpPopper,
    SpIcon
  },

  directives: { clickoutside },

  mixins: [WHcomputed],
  provide () {
    return {
      SpPopperTrigger: computed(() => {
        return {
          dom: () => {
            return this.$refs.datePicker
          }
        }
      })
    }
  },

  props: {
    width: {
      type: [Number, String],
      default: 200
    },

    disabled: {
      type: Boolean,
      default: false
    },

    height: {
      type: [Number, String],
      default: 50
    },

    popStyle: {
      type: Object,
      default: () => {
        return null
      }
    },

    popClass: {
      type: [String, Object, Array],
      default: ''
    },

    type: {
      type: String,
      default: 'normal'
    },

    modelValue: {
      type: [String, Date],
      default: ''
    },

    defaultValue: {
      type: [String, Date],
      default: ''
    },

    placeholder: {
      type: String,
      default: ''
    },

    border: Boolean,
    icon: {
      type: Boolean,
      default: true
    },

    format: { // model格式
      type: String,
      default: 'yyyy-MM-dd'
    },

    filter: { // 仅改变显示的内容，不影响model
      type: [Boolean, Function],
      default: false
    },

    pickerType: {
      type: String,
      default: 'day'
    },

    showClose: {
      type: Boolean,
      default: true
    },

    ...useFormItemProps()
  },

  emits: ['update:modelValue', 'click-change'],
  setup (props, ctx) {
    const showPicker = ref(false)// 展示日期选择框
    const openPicker = () => {
      if (!props.disabled) {
        showPicker.value = !showPicker.value
      }
    }
    const pickerOption = ref(props.pickerType)// 日期选择类型
    const year = ref(0)
    const month = ref(0)
    const day = ref(0)
    const week = ref(0)
    const hour = ref(0)
    const minute = ref(0)
    const second = ref(0)
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    const years = ref({})
    const modelLocal = ref(props.defaultValue)
    const model = computed({
      get: () => {
        return formModel.get(props.name) || props.modelValue || modelLocal.value
      },
      set: (val) => {
        ctx.emit('update:modelValue', val)
        if (formModel) {
          formModel.set(val, props.name)
        }
        modelLocal.value = val
        nextTick(() => {
          if (errorMsg.value && !validate()) { // 输入验证通过去除红框
            errorMsg.value = ''
          }
        })
      }
    })

    const {
      errorMsg,
      validate,
      formModel
    } = useForm(toRef(props, 'name'), 'input', model, props.required,
      props.validateReg, props.errorMsgFun)

    const formatDate = computed(() => {
      return props.format.replace('MM', (Array(2).join(0) + month.value).slice(-2)).toLowerCase().replace('yyyy', year.value)
        .replace('dd', (Array(2).join(0) + day.value).slice(-2)).replace('hh', hour.value).replace('mm', minute.value).replace('ss', second.value)
      // return new Date(date).toLocaleDateString()
    })

    const filterDate = computed(() => {
      const filter = typeof props.filter === 'function' ? props.filter : (date) => {
        const day = date.getDate()
        const suffix = ['st', 'nd', 'rd', 'th']
        if (props.pickerType === 'month') {
          return `${months[date.getMonth()].slice(0, 3)} ${date.getFullYear()}`
        } else {
          return `${day}${day < 4 ? suffix[day - 1] : suffix[3]} ${months[date.getMonth()].slice(0, 3)} ${date.getFullYear()}`
        }
      }
      return filter(getDate(model.value, props.format))
    })

    // 显示的数据
    const label = computed(() => {
      if (model.value) {
        return props.filter ? filterDate.value : model.value
      } else {
        return props.placeholder || (props.filter ? filterDate.value : model.value)
      }
    })

    const days = computed(() => {
      const lastDay = new Date(year.value, month.value, 0).getDate()
      const days = []
      for (let i = 1; i < lastDay + 1; i++) {
        days.push({ curr: true, date: i })
      }
      const firstDayWeek = new Date(year.value, month.value - 1, 1).getDay() || 7

      const lastMonthLastDay = new Date(year.value, month.value - 1, 0).getDate()

      for (let i = 0; i < firstDayWeek; i++) {
        days.unshift({ last: true, date: lastMonthLastDay - i })
      }

      const lastDayWeek = new Date(year.value, month.value, 0).getDay()
      let lastWeekHaveNext = 0
      for (let i = 1; i <= 7 - lastDayWeek - 1; i++) {
        days.push({ next: true, date: i })
        lastWeekHaveNext++
      }
      if (days.length < 42) {
        // const lastDay = days[days.length - 1].date
        for (let i = 1; days.length < 42; i++) {
          days.push({ next: true, date: lastWeekHaveNext + i })
        }
      }
      const list = {}
      for (const key in days) {
        list[Math.floor(key / 7)] = list[Math.floor(key / 7)] || {}
        list[Math.floor(key / 7)][key % 7] = days[key]
      }
      if (list[1][0].date === 1) {
        delete list[0]
      }
      // if (_intersection(Object.values(list[4]).map(item => item.date), [1, 2, 3, 4, 5, 6, 7]).length > 0 && list[5]) {
      //   delete list[5]
      // }
      return list
    })

    const { widthC, heightC } = useSize(toRef(props, 'width'), toRef(props, 'height'))

    const style = computed(() => {
      const style = { }
      style.width = style.width || widthC.value
      style.height = style.height || heightC.value
      if (props.border) {
        style.borderStyle = 'solid'
        style.borderWidth = '1px'
      }
      return style
    })

    const classes = computed(() => {
      const classes = Array.isArray(props.popClass) ? [...props.popClass] : [props.popClass]
      let type = THEME[props.type]
      if (props.border) {
        type = type.replace('bg', 'bd')
      }
      if (errorMsg?.value) {
        classes.push('sp-color-bd-1', 'sp-error-date')
      }
      if (props.disabled) {
        classes.push('disable')
      }
      return [...classes, type]
    })

    // methods
    const nextPicker = (type) => {
      const types = [{ type: 'year', format: 'YYYY' }, { type: 'month', format: 'MM' }, { type: 'day', format: 'DD' }]
      const nextIndex = types.findIndex(i => { return i.type === type }) + 1
      if (props.format.toUpperCase().includes(types[nextIndex]?.format)) {
        return types[nextIndex].type
      } else {
        return type
      }
    }

    const setDate = (date) => {
      if (date instanceof Date) {
        year.value = date.getFullYear()
        month.value = date.getMonth() + 1
        week.value = date.getDay()
        day.value = date.getDate()
        hour.value = date.getHours()
        minute.value = date.getMinutes()
        second.value = date.getSeconds()
      }
    }
    const closePicker = () => {
      if (showPicker.value === false) {
        return
      }
      showPicker.value = false
    }

    const addYear = (num) => {
      if (pickerOption.value !== 'year') {
        year.value += num
      } else {
        const yearsOld = Object.values(years.value)
        const yearsNew = []
        if (num > 0) {
          const year = yearsOld[yearsOld.length - 1]
          for (let i = 1; i < 21; i++) {
            yearsNew.push(year + i)
          }
        } else {
          const year = yearsOld[0]
          for (let i = 1; i < 21; i++) {
            yearsNew.unshift(year - i)
          }
        }

        years.value = { ...yearsNew }
      }
    }

    const addMonth = (num) => {
      const newMonth = month.value + num
      const lastDay = new Date(year.value, newMonth, 0).getDate()
      if (newMonth > 12) {
        month.value = newMonth % 12
        addYear(Math.floor(newMonth / 12))
      } else if (newMonth < 1) {
        month.value = newMonth % 12 + 12
        addYear(Math.ceil(-newMonth / 12) - 1)
      } else {
        month.value = newMonth
      }
      if (lastDay < day.value) {
        day.value = 1
      }
    }

    const setDay = (d) => {
      day.value = d.date
      addMonth(d.last ? -1 : d.next ? 1 : 0)
      showPicker.value = false// 关闭选择框
      ctx.emit('click-change')
    }

    const setMonth = (m) => {
      month.value = m
      if (props.pickerType !== 'month') {
        pickerOption.value = nextPicker('month')
      }
    }

    const setYear = (y) => {
      year.value = y
      pickerOption.value = nextPicker('year')
    }

    const getMonth = (month) => {
      return months[month - 1]
    }

    const pickYear = () => {
      const yearsNew = [year.value]
      for (let i = 1; i < 11; i++) {
        yearsNew.push(year.value + i)
        yearsNew.unshift(year.value - i)
      }
      years.value = { ...yearsNew.slice(0, -1) }
      pickerOption.value = 'year'
    }
    // 改变model
    const regenPosition = () => {
      if (isDate(model.value)) {
        model.value = getDate(formatDate.value, props.format)
      } else {
        model.value = formatDate.value
      }
    }

    // created
    setDate(getDate(props.modelValue || props.defaultValue || new Date(), props.format))
    if (!props.pickerType && props.format) { // 没控制类型则自动生成
      if (!props.format.toLowerCase().includes('dd')) {
        if (!props.format.includes('MM')) {
          pickerOption.value = 'year'
        } else {
          pickerOption.value = 'month'
        }
      }
    }
    watch(() => props.modelValue, (item) => {
      let date = new Date(props.modelValue)
      if (!props.modelValue) {
        date = new Date()
      }
      setDate(date)
    })
    return {
      showPicker,
      pickerOption,
      openPicker,
      year,
      month,
      day,
      week,
      hour,
      minute,
      second,
      months,
      years,
      formatDate,
      filterDate,
      label,
      days,
      style,
      classes,
      model,
      nextPicker,
      setDate,
      closePicker,
      addYear,
      addMonth,
      setMonth,
      setDay,
      setYear,
      getMonth,
      pickYear,
      regenPosition,
      errorMsg

    }
  }
}
</script>

<style scoped lang="less">
.SpDatePicker{
  display: inline-flex;
  cursor: pointer;
  &[class*=disable]{
    //pointer-events: none;
    cursor: not-allowed !important;
  }
  &[class*=sp-error-date]{
    border: 1px solid red !important;
  }
  .input{
    //cursor: pointer;
    display: flex;
    align-items: center;
    width:100%;
    position: relative;
    .icon{
      padding: 0 10px;
    }
    .label{
      font-size: 14px;
    }
    .close-icon{
      position: absolute;
      right: 6px;
      top: 50%;
      transform: translateY(-50%);
      opacity: 0.6;
    }
  }
  // .input::before{//居中文字
  //   display: inline-block;
  //   content: "";
  //   height: 100%;
  //   vertical-align: middle;
  // }
}
.datepicker{
  padding:20px;
  .datepicker-panel{
    position: relative;
  }
  .datepicker-year-month{
    display: flex;
    justify-content: space-between;
    .label{
      font-size: 18px;
      font-family: Arial;
      font-weight: 700;
      cursor: pointer;
      .label-month{
        margin-left: 30px;
      }
    }
    .arrow-left{
      cursor: pointer;
      // transform: rotate(90deg);
    }
    .arrow-right{
      cursor: pointer;
      transform: rotate(180deg);
    }
  }
  .datepicker-day{
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid black;
    position: absolute;
    top:0;
    .picker-days{
      width: 100%;
      text-align: center;
      .picker-day{
        cursor: pointer;
        width:60px;
        height:40px;
      }
      .last-month-date,.next-month-date{
        color:fade(black,30);
      }
      .picker-day:hover{
        // background-color: red;
      }
    }
  }
  .datepicker-month{
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid black;
    position: absolute;
    top:0;
    .picker-months{
      width: 100%;
      text-align: center;
      .picker-month{
        cursor: pointer;
        width:120px;
        height:80px;
      }
    }
  }
  .datepicker-year{
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid black;
    position: absolute;
    top:0;
    .picker-years{
      width: 100%;
      text-align: center;
      .picker-year{
        cursor: pointer;
        width:100px;
        height:70px;
      }
    }
  }
}
.tst-scale-enter-active,.tst-scale-leave-active {
  transition: opacity 300ms cubic-bezier(0.23, 1, 0.32, 1), -webkit-transform 300ms cubic-bezier(0.23, 1, 0.32, 1);
  transition: transform 300ms cubic-bezier(0.23, 1, 0.32, 1), opacity 300ms cubic-bezier(0.23, 1, 0.32, 1);
  transition: transform 300ms cubic-bezier(0.23, 1, 0.32, 1), opacity 300ms cubic-bezier(0.23, 1, 0.32, 1), -webkit-transform 300ms cubic-bezier(0.23, 1, 0.32, 1);
}
.tst-scale-enter-from, .tst-scale-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: scale(0,0);
}
</style>
